import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Box,
  Typography,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Grid,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Chip,
  Snackbar,
  colors,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { TablePagination } from "@material-ui/core";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Close as CloseIcon,
} from "@material-ui/icons";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import axios from "axios";
import { URL as CLIENT_URL } from "../../config/config";
import { Alert, Skeleton } from "@material-ui/lab";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import moment from "moment-timezone";
import { el } from "date-fns/locale";
import { verifySubRouteAction } from "../../helpers/accessControlHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    height: "100vh",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  header: {
    marginBottom: theme.spacing(3),
  },

  tabPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    marginTop: theme.spacing(3),
  },

  tableWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "white",
    // borderRadius: theme.shape.borderRadius,
    height: "calc(100vh - 150px)",
  },

  tableContainer: {
    flex: 1,
    overflow: "auto",
    "& .MuiTableContainer-root": {
      overflow: "auto",
    },
  },

  table: {
    minWidth: 2200,
  },

  tableCell: {
    fontSize: "14px",
    padding: "3px 22px",
    whiteSpace: "nowrap",
    "&.MuiTableCell-head": {
      backgroundColor: "#ebf5f3",
      fontWeight: "bold",
      fontSize: "15px",
      position: "sticky",
      top: 0,
      zIndex: 2,
    },
  },

  pagination: {
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: "white",
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    width: "100%",
    "& .MuiTablePagination-toolbar": {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      "& .MuiTablePagination-spacer": {
        display: "none",
      },
    },
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "#ebf5f3",
    },
  },

  chip: {
    margin: theme.spacing(0.5),
  },

  select: {
    minWidth: 150,
  },

  analyticsContainer: {
    padding: theme.spacing(2),
    width: "100%",
    boxSizing: "border-box",
    overflowY: "auto",
    height: "calc(100vh - 180px)",
  },

  summaryCards: {
    marginBottom: theme.spacing(4),
    display: "flex",
    flexWrap: "nowrap",
  },

  chartsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  chartContainer: {
    backgroundColor: "white",
    padding: theme.spacing(3),
    // borderRadius: theme.shape(1),
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "100%",
    boxSizing: "border-box",
    height: "400px",
  },

  card: {
    height: "100%",
  },

  dialogContent: {
    minWidth: 500,
  },

  notesSection: {
    marginTop: theme.spacing(2),
  },

  note: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.spacing(1),
  },

  flexRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"];

const CS_REPRESENTATIVES = [
  "Akshay",
  "Samarth Srivastava",
  "Mayank Dixit",
  "Bhavik Lad",
  "Shikha Sharma",
  "Navjot Singh Narang",
  "Shubham Khurana",
  "Bilal Khan",
  "Shivam Thapliyal",
  "Shekhar Vashisth",
  "Jigar Raichada",
  "Abhishek Verma",
  "Nishant Garg",
  "Rohit Singh",
  "Krishna Sharma",
  "Yogita",
  "Shubham Singha",
  "Rishabh khanna",
  "Yatendra Mishra",
  "Abhinav Srivastava",
  "Devesh Kumar",
  "Chaitanya Aneja",
  "Sourav Mondal",
  "Aniket Singh",
  "Kumar Satyam",
  "Sahil Lamba",
  "Kartik Chauhan",
  "Sanjukta Mukherjee",
  "Aditya Vashishtha",
  "Burhan Rouf",
  "Inderjeet Jaggi",
  "Mohd Kashif",
  "Shubham Gupta",
  "Khushwant",
  "Prince Tyagi",
  "Animesh Singh",
  "Gurdeep Singh",
  "Ansh Sharma",
];

const VOID_REASON = ["Upsell", "Renewal", "Tech issue"];
const STATUS = ["Pending", "Activated", "Voided"];
const SOURCE = [
  "Meta Ads",
  "Google Ads",
  "Callback Team",
  "SMB Team",
  "Unknown",
];

const LEAD_STATUSES = [
  "New",
  "Contacted",
  "In Progress",
  "Setup Complete",
  "With Finance",
  "Closed",
];

const bvbpProcessMapping = {
  0: "Not Started (0)",
  1: "User submitted (1)",
  2: "Forwarded to Meta (2)",
  3: "Limit increased (3)",
  4: "Account not eligible for kyc (4)",
};

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box style={{ width: "100%" }}>{children}</Box>}
    </div>
  );
}

const AccessCodeDashboard = (props) => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const [data, setData] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [openLeadDialog, setOpenLeadDialog] = useState(false);
  const [openVoidDialog, setOpenVoidDialog] = useState(false);
  const [voidReason, setVoidReason] = useState("");
  const [newNote, setNewNote] = useState("");
  const [assistantId, setAssistantId] = useState("");
  const [selectedAssigneeDropdown, setSelectedAssigneeDropdown] = useState("");
  const [selectedStatusDropdown, setSelectedStatusDropdown] = useState("");
  const [selectedSourceDropdown, setSelectedSourceDropdown] = useState("");
  const [selectedVoidDropdown, setSelectedVoidDropdown] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [analyticsData, setAnalyticsData] = useState([]);
  const [isAnalyticsLoading, setIsAnalyticsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const getVisibleTabs = () => {
    const { permissions } = props;
    const offerCodePermission = permissions.find(
      (p) => p.label === "diwali-offer-codes"
    );
    if (!offerCodePermission || !Array.isArray(offerCodePermission.subroutes))
      return [];
    // Map label to display name and original index
    const labelMap = {
      customerData: { display: "Customer Data", originalIndex: 0 },
      analytics: { display: "Analytics", originalIndex: 1 },
    };
    return offerCodePermission.subroutes
      .filter((sr) => sr.read)
      .map((sr) => ({
        label: sr.label,
        display: labelMap[sr.label]?.display || sr.label,
        originalIndex: labelMap[sr.label]?.originalIndex,
        write: sr.write,
        actions: sr.actions,
      }));
  };

  // Helper to get the current tab info
  const getCurrentTab = () => {
    const visibleTabs = getVisibleTabs();
    return visibleTabs[tabValue];
  };

  const hasWriteAccess = () => {
    const visibleTabs = getVisibleTabs();
    return visibleTabs[tabValue]?.write;
  };

  // Initialize tabValue to first visible tab
  useEffect(() => {
    const visibleTabs = getVisibleTabs();
    if (visibleTabs.length === 0) return; // No tabs to show
    if (tabValue >= visibleTabs.length) {
      setTabValue(0);
    }
  }, [props.permissions]);

  const fetchData = async (query) => {
    setIsTableLoading(true);
    try {
      const response = await axios.get(
        `${CLIENT_URL}/superadmin/get-swipe-logs?page=${page}&limit=${rowsPerPage}&search=${query}`
      );
      setData(response.data.data);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching data:", error);
      handleSnackBar("Error loading customer data", "error");
    } finally {
      setIsTableLoading(false);
    }
  };

  const fetchAnalyticsData = async () => {
    setIsAnalyticsLoading(true);
    try {
      const response = await axios.get(
        `${CLIENT_URL}/superadmin/get-swipe-logs?page=0&limit=9999999`
      );
      setAnalyticsData(response.data.data);
    } catch (error) {
      console.error("Error fetching analytics data:", error);
      handleSnackBar("Error loading analytics data", "error");
    } finally {
      setIsAnalyticsLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    const visibleTabs = getVisibleTabs();
    const currentTab = visibleTabs[newValue];

    setTabValue(newValue);

    // Check if we need to fetch analytics data (original index 1)
    if (currentTab?.originalIndex === 1 && analyticsData.length === 0) {
      fetchAnalyticsData();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getDailyPurchasesData = () => {
    const purchasesByDate = analyticsData.reduce((acc, item) => {
      const dateString = moment(item.createdAt)
        .tz("Asia/Kolkata")
        .format("YYYY-MM-DD");
      acc[dateString] = (acc[dateString] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(purchasesByDate)
      .map(([date, count]) => ({
        date: moment(date).format("DD/MM/YYYY"),
        purchases: count,
        sortDate: date,
      }))
      .sort((a, b) => new Date(a.sortDate) - new Date(b.sortDate))
      .map(({ date, purchases }) => ({ date, purchases }));
  };

  const getDailyAmountData = () => {
    const amountByDate = analyticsData.reduce((acc, item) => {
      const dateString = moment(item.createdAt)
        .tz("Asia/Kolkata")
        .format("YYYY-MM-DD");
      acc[dateString] =
        (acc[dateString] || 0) + (item.body?.transaction?.price?.amount || 0);
      return acc;
    }, {});

    return Object.entries(amountByDate)
      .map(([date, amount]) => ({
        date: moment(date).format("DD/MM/YYYY"),
        amount,
        sortDate: date,
      }))
      .sort((a, b) => new Date(a.sortDate) - new Date(b.sortDate))
      .map(({ date, amount }) => ({ date, amount }));
  };

  const getPaymentMethodsData = () => {
    const methodCounts = analyticsData.reduce((acc, item) => {
      const method = item.body?.paymentDetails?.method || "unknown";
      acc[method] = (acc[method] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(methodCounts).map(([method, value]) => ({
      name: method.toUpperCase(),
      value,
    }));
  };

  const getPlanDistributionData = () => {
    const planCounts = analyticsData.reduce((acc, item) => {
      const planName = item?.body?.product?.name || "Unknown";
      acc[planName] = (acc[planName] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(planCounts).map(([plan, count]) => ({
      plan,
      count,
    }));
  };

  const getWhatsAppStatusData = () => {
    const verified = analyticsData.filter(
      (item) => item.assistantData?.isWhatsappVerified
    ).length;
    const notVerified = analyticsData.length - verified;

    return [
      { name: "Verified", value: verified },
      { name: "Not Verified", value: notVerified },
    ];
  };

  const getCodeActivationData = () => {
    const activated = analyticsData.filter(
      (item) => item.accessTokenUsed
    ).length;
    const pending = analyticsData.length - activated;

    return [
      { name: "Activated", value: activated },
      { name: "Pending", value: pending },
    ];
  };

  const getAdCreditsData = () => {
    const totalCredits = analyticsData.reduce(
      (sum, item) => sum + (item.ctwaAmount || 0),
      0
    );
    const activatedCredits = analyticsData.reduce(
      (sum, item) =>
        sum + (item.ctwaAmount && item.accessTokenUsed ? item.ctwaAmount : 0),
      0
    );

    return [
      { name: "Total Credits", value: totalCredits },
      { name: "Activated Credits", value: activatedCredits },
    ];
  };

  const getSourceDistributionData = () => {
    const sources = analyticsData.reduce((acc, item) => {
      let source = "Unknown";
      if (item.smbTeam) source = "SMB Team";
      else if (item.requestCallBackTeam) source = "Callback Team";
      else if (item.googleAds) source = "Google Ads";
      else if (item.metaAds) source = "Meta Ads";

      acc[source] = (acc[source] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(sources).map(([name, value]) => ({ name, value }));
  };

  const getAdSourceData = () => {
    const adSources = analyticsData.reduce((acc, item) => {
      if (item.googleAds) acc.google = (acc.google || 0) + 1;
      if (item.metaAds) acc.meta = (acc.meta || 0) + 1;
      return acc;
    }, {});

    return [
      { name: "Google Ads", value: adSources.google || 0 },
      { name: "Meta Ads", value: adSources.meta || 0 },
    ];
  };

  const closeSnackbar = () => {
    setAlert(false);
    setAlertMsg("");
    setAlertSeverity("");
  };

  const getSummaryData = () => {
    const totalPurchases = analyticsData.length;
    const totalSales = analyticsData.reduce(
      (sum, item) => sum + (item.body?.transaction?.price?.amount || 0),
      0
    );
    const totalRevenue = totalSales / 1.18;
    const activatedCodes = analyticsData.filter(
      (item) => item.accessTokenUsed
    ).length;
    const whatsappVerified = analyticsData.filter(
      (item) => item.assistantData?.isWhatsappVerified
    ).length;

    return {
      totalPurchases,
      totalSales,
      totalRevenue,
      activatedCodes,
      whatsappVerified,
    };
  };

  const AnalyticsLoadingSkeleton = () => (
    <div className={classes.analyticsContainer}>
      <Grid container spacing={3} className={classes.summaryCards}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Grid item xs={3} key={item}>
            <Card className={classes.card}>
              <CardContent>
                <Skeleton width="60%" height={20} />
                <Skeleton width="40%" height={40} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <div className={classes.chartsGrid}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div key={item} className={classes.chartContainer}>
            <Skeleton width="40%" height={30} style={{ marginBottom: 20 }} />
            <Skeleton width="100%" height={300} />
          </div>
        ))}
      </div>
    </div>
  );

  const TableLoadingSkeleton = () => (
    <div className={classes.tableWrapper}>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table stickyHeader className={classes.table}>
          <TableHead>
            <TableRow>
              {[...Array(props.agent.power > 9 ? 8 : 8)].map((_, index) => (
                <TableCell key={index} className={classes.tableCell}>
                  <Skeleton variant="text" width={200} height={40} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(15)].map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {[...Array(props.agent.power > 9 ? 8 : 8)].map(
                  (_, colIndex) => (
                    <TableCell key={colIndex} className={classes.tableCell}>
                      <Skeleton
                        variant="text"
                        width={colIndex === 0 ? 250 : 200}
                        height={30}
                      />
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={0}
        rowsPerPage={rowsPerPage}
        page={0}
        onPageChange={() => {}}
        onRowsPerPageChange={() => {}}
      />
    </div>
  );

  // Event handlers
  const handleLeadClick = (lead) => {
    setSelectedLead(lead);
    setOpenLeadDialog(true);
  };

  const handleSnackBar = (msg, severity) => {
    setAlert(true);
    setAlertMsg(msg);
    setAlertSeverity(severity);
  };

  const handleAssignCS = async (leadId, csRepresentative) => {
    try {
      await axios.post(`${CLIENT_URL}/superadmin/assign-cs`, {
        leadId,
        csRepresentative,
      });

      handleSnackBar(
        `CS representative assigned to - ${csRepresentative}`,
        "success"
      );
      setSelectedAssigneeDropdown("");
      setSelectedStatusDropdown("");
      setSelectedSourceDropdown("");

      fetchData(searchQuery);
    } catch (error) {
      console.error("Error assigning CS rep:", error);
      handleSnackBar(`Error assigning CS representative`, "error");
    }
  };

  useEffect(() => {
    const currentTab = getCurrentTab();
    if (currentTab?.originalIndex === 1 && analyticsData.length === 0) {
      fetchAnalyticsData();
    } else {
      const fetchData = async () => {
        setIsTableLoading(true);

        try {
          const params = new URLSearchParams({
            page,
            limit: rowsPerPage,
          });

          if (searchValue) {
            params.append("search", searchValue);
          }

          if (selectedAssigneeDropdown && selectedAssigneeDropdown !== "None") {
            params.append("filter[csRepresentative]", selectedAssigneeDropdown);
          } else if (selectedAssigneeDropdown === "None") {
            params.append("filter[csRepresentative]", "");
          }

          if (selectedStatusDropdown && selectedStatusDropdown !== "None") {
            params.append("filter[status]", selectedStatusDropdown);
          } else if (selectedStatusDropdown === "None") {
            params.append("filter[status]", "");
          }
          if (selectedSourceDropdown && selectedSourceDropdown !== "None") {
            params.append("filter[source]", selectedSourceDropdown);
          } else if (selectedSourceDropdown === "None") {
            params.append("filter[source]", "");
          }

          const response = await axios.get(
            `${CLIENT_URL}/superadmin/get-swipe-logs?${params.toString()}`
          );

          setData(response.data.data);
          setTotal(response.data.total);
        } catch (error) {
          console.error("Error fetching data:", error);
          handleSnackBar("Error loading customer data", "error");
        } finally {
          setIsTableLoading(false);
        }
      };

      fetchData();
    }
  }, [
    page,
    rowsPerPage,
    searchValue,
    selectedAssigneeDropdown,
    selectedStatusDropdown,
    selectedSourceDropdown,
  ]);

  const assigneeDropdownHandler = (query) => {
    setSelectedAssigneeDropdown(query);
  };

  const statusDropdownHandler = (query) => {
    setSelectedStatusDropdown(query);
  };
  const sourceDropdownHandler = (query) => {
    setSelectedSourceDropdown(query);
  };

  const setVoidDropdownHandler = (value) => {
    setSelectedVoidDropdown(value);
  };

  const handleStatusUpdate = async (leadId, status) => {
    try {
      await axios.post(`${CLIENT_URL}/superadmin/update-lead-status`, {
        leadId,
        status,
      });

      handleSnackBar(`Lead status updated to - ${status}`, "success");

      fetchData(searchQuery);
    } catch (error) {
      console.error("Error updating lead status:", error);
      handleSnackBar(`Error updating lead status`, "error");
    }
  };

  const handleVoidCode = async (leadId, accessToken) => {
    const objectIdRegex = /^[0-9a-fA-F]{24}$/;

    if (!voidReason.trim() || !selectedVoidDropdown.trim()) {
      handleSnackBar("Please provide a valid reason and sub-reason", "error");
      return;
    }
    try {
      await axios.post(`${CLIENT_URL}/superadmin/void-access-code`, {
        leadId,
        reason: voidReason,
        subReason: selectedVoidDropdown,
        accessToken,
      });

      handleSnackBar("Access code voided successfully", "success");
      fetchData(searchQuery);
      setOpenVoidDialog(false);
      setVoidReason("");
      setAssistantId("");
      setSelectedVoidDropdown("");
      setSelectedStatusDropdown("");
      setSelectedSourceDropdown("");
      setSelectedAssigneeDropdown("");
      setSearchQuery("");
      setSearchValue("");
    } catch (error) {
      console.error("Error voiding access code:", error);
      handleSnackBar("Error voiding access code", "error");
    }
  };

  const handleRowClick = (row) => {
    let isSelectingText = false;
    let mouseDownTime = 0;
    const selection = window.getSelection();

    return {
      onMouseDown: (e) => {
        // Only track mouse down on table cells (not buttons/selects/chips)
        if (
          e.target.closest(".MuiTableCell-root") &&
          !e.target.closest("button") &&
          !e.target.closest(".MuiSelect-root") &&
          !e.target.closest(".MuiChip-root")
        ) {
          mouseDownTime = Date.now();
          isSelectingText = false;
        }
      },
      onMouseMove: () => {
        // If user moves mouse after mousedown, they're probably selecting text
        if (mouseDownTime > 0) {
          isSelectingText = true;
        }
      },
      onClick: (e) => {
        // Only trigger if:
        // 1. Not selecting text
        // 2. Mouse was down for less than 200ms (quick click)
        // 3. No text is actually selected
        const hasSelection = selection && selection.toString().length > 0;
        const isQuickClick = Date.now() - mouseDownTime < 200;

        if (
          !isSelectingText &&
          isQuickClick &&
          !hasSelection &&
          e.target.closest(".MuiTableCell-root") &&
          !e.target.closest("button") &&
          !e.target.closest(".MuiSelect-root") &&
          !e.target.closest(".MuiChip-root")
        ) {
          handleLeadClick(row);
        }
        mouseDownTime = 0;
        isSelectingText = false;
      },
    };
  };

  function convertToIST(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  }

  const handleAddNote = async () => {
    if (!newNote.trim()) {
      handleSnackBar("Please provide a note", "error");
      return;
    }

    try {
      await axios.post(`${CLIENT_URL}/superadmin/add-note`, {
        leadId: selectedLead._id,
        note: newNote,
      });
      const { data } = await axios.get(
        `${CLIENT_URL}/superadmin/get-lead/${selectedLead._id}`
      );

      handleSnackBar("Note added successfully", "success");
      setSelectedLead(data?.data);
      setData((prevData) =>
        prevData.map((item) =>
          item._id === selectedLead._id ? data?.data : item
        )
      );
      setNewNote("");
    } catch (error) {
      console.error("Error adding note:", error);
      handleSnackBar("Error adding note", "error");
    }
  };

  const { permissions } = props;
  const accessCodePermission = permissions.find(
    (p) => p.label === "diwali-offer-codes"
  );
  const customerDataPermission = accessCodePermission.subroutes.find(
    (route) => route.key === "customerData"
  );

  const accessCodeActionPermission = verifySubRouteAction(
    customerDataPermission,
    "accessCodes"
  );

  return (
    <div className={classes.root}>
      <div
        className={classes.header}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4">Offer Access Codes</Typography>
        <Box
          style={{
            gap: "8px",
          }}
        >
          {/* Source Select */}
          <FormControl
            fullWidth
            style={{ marginRight: "8px", marginBottom: "10px", width: "250px" }}
          >
            <Select
              labelId="status-select-label"
              value={selectedSourceDropdown}
              onChange={(e) => sourceDropdownHandler(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              displayEmpty
              style={{
                height: "52px",
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "0 20px",
              }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Typography style={{ color: "#666" }}>Source</Typography>
                  );
                }
                return selected;
              }}
              endAdornment={
                selectedSourceDropdown && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      sourceDropdownHandler("");
                    }}
                    style={{ marginRight: "-8px" }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )
              }
            >
              {SOURCE.map((rep) => (
                <MenuItem key={rep} value={rep}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    {rep}
                  </span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Status Select */}
          <FormControl
            fullWidth
            style={{ marginRight: "8px", marginBottom: "10px", width: "250px" }}
          >
            <Select
              labelId="status-select-label"
              value={selectedStatusDropdown}
              onChange={(e) => statusDropdownHandler(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              displayEmpty
              style={{
                height: "52px",
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "0 20px",
              }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Typography style={{ color: "#666" }}>
                      Select status
                    </Typography>
                  );
                }
                return selected;
              }}
              endAdornment={
                selectedStatusDropdown && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      statusDropdownHandler("");
                    }}
                    style={{ marginRight: "-8px" }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )
              }
            >
              {STATUS.map((rep) => (
                <MenuItem key={rep} value={rep}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    {rep}
                  </span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Assignee Select */}
          <FormControl
            fullWidth
            style={{ marginRight: "8px", marginBottom: "10px", width: "250px" }}
          >
            <Select
              labelId="assignee-select-label"
              value={selectedAssigneeDropdown}
              onChange={(e) => assigneeDropdownHandler(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              displayEmpty
              style={{
                height: "52px",
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "0 20px",
              }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Typography style={{ color: "#666" }}>
                      Select assignee
                    </Typography>
                  );
                }
                return selected;
              }}
              endAdornment={
                selectedAssigneeDropdown && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      assigneeDropdownHandler("");
                    }}
                    style={{ marginRight: "-8px" }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )
              }
            >
              {CS_REPRESENTATIVES.map((rep) => (
                <MenuItem key={rep} value={rep}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    {rep}
                  </span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            placeholder="Search by email, phone, access code"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearchValue(searchQuery); // trigger the search
              }
            }}
            style={{ width: "300px" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearchQuery("");
                      setSearchValue(""); // clear the search
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </div>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {getVisibleTabs().map((tab, idx) => (
          <Tab key={tab.label} label={tab.display} />
        ))}
      </Tabs>

      {/* Customer Data Tab */}
      {getCurrentTab()?.originalIndex === 0 && (
        <TabPanel value={tabValue} index={tabValue}>
          {isTableLoading ? (
            <TableLoadingSkeleton />
          ) : (
            <div className={classes.tableWrapper}>
              <TableContainer
                component={Paper}
                className={classes.tableContainer}
              >
                <Table stickyHeader className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableCell}>
                        Plan Name
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Created At
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Updated At
                      </TableCell>
                      {accessCodeActionPermission && (
                        <TableCell className={classes.tableCell}>
                          Access Code
                        </TableCell>
                      )}
                      <TableCell className={classes.tableCell}>
                        Source
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Code Status
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        WABA Status
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Assigned person
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Existing User
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Project Id
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Ads Spent
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Total No. of Ads
                      </TableCell>

                      <TableCell className={classes.tableCell}>Name</TableCell>
                      <TableCell className={classes.tableCell}>Email</TableCell>
                      <TableCell className={classes.tableCell}>
                        Mobile
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Amount Paid
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        CTWA Amount
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Flow Price
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Plan Price
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        User Status
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        Payment ID
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow
                        key={index}
                        hover
                        {...handleRowClick(row)}
                        className={classes.tableRow}
                      >
                        <TableCell className={classes.tableCell}>
                          {row.flowAddOn
                            ? `${row.planName} + Flow`
                            : row.planName}{" "}
                          🔥
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {new Date(row.createdAt).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                          })}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {new Date(row.updatedAt).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                          })}
                        </TableCell>

                        {accessCodeActionPermission && (
                          <TableCell className={classes.tableCell}>
                            {row.accessToken}

                            <IconButton
                              size="small"
                              onClick={() =>
                                navigator.clipboard.writeText(row.accessToken)
                              }
                              style={{ marginLeft: 8 }}
                            >
                              <FileCopyOutlinedIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        )}

                        <TableCell className={classes.tableCell}>
                          {row.smbTeam ? (
                            <span style={{ color: "#3b8132" }}>SMB Team</span>
                          ) : row.requestCallBackTeam ? (
                            <span style={{ color: "#9B51E0" }}>
                              Request Call Back Team
                            </span>
                          ) : row.googleAds ? (
                            <span style={{ color: "#FF9900" }}>Google Ads</span>
                          ) : row.metaAds ? (
                            <span style={{ color: "#4285F4" }}>Meta Ads</span>
                          ) : (
                            <span style={{ color: "gray" }}>Unknown</span>
                          )}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Chip
                            label={
                              row.accessTokenUsed && row.voidInfo?.isVoided
                                ? "Voided"
                                : row.accessTokenUsed
                                ? "Activated"
                                : "Pending"
                            }
                            className={classes.chip}
                            style={
                              row.accessTokenUsed && row.voidInfo?.isVoided
                                ? {
                                    backgroundColor: "rgb(116 40 193)",
                                    color: "white",
                                  }
                                : row.accessTokenUsed
                                ? {
                                    backgroundColor: "rgb(40, 193, 82)",
                                    color: "white",
                                  }
                                : { backgroundColor: "#FFBB28", color: "black" }
                            }
                          />
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row?.assistantData?.isWhatsappVerified &&
                          row?.assistantData?.wabaProgressStep === 9 ? (
                            <span style={{ color: "#06402B" }}>Verified</span>
                          ) : (
                            ""
                          )}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Select
                            value={row.csRepresentative || "None"}
                            onChange={(e) =>
                              handleAssignCS(row._id, e.target.value)
                            }
                            onClick={(e) => e.stopPropagation()}
                            className={classes.select}
                            disabled={!hasWriteAccess()}
                          >
                            <MenuItem value="None">None</MenuItem>
                            {CS_REPRESENTATIVES.map((rep) => (
                              <MenuItem key={rep} value={rep}>
                                {rep}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {Object.keys(row.existingAgent || {}).length > 0 ? (
                            <span style={{ color: "black" }}>Yes</span>
                          ) : (
                            <span style={{ color: "black" }}>No</span>
                          )}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row.assistantId}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row.totalAdSpend || null}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row.totalAdsData || null}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row.body?.customer?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.body?.customer?.email}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.body?.customer?.phone}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          ₹{row.body?.transaction?.price?.amount}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          ₹{row.ctwaAmount || "N/A"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          ₹{row.flowPrice || "N/A"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          ₹{row.planAmount || "N/A"}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Select
                            value={row.leadStatus || "New"}
                            onChange={(e) =>
                              handleStatusUpdate(row._id, e.target.value)
                            }
                            onClick={(e) => e.stopPropagation()}
                            className={classes.select}
                            disabled={!hasWriteAccess()}
                          >
                            {LEAD_STATUSES.map((status) => (
                              <MenuItem key={status} value={status}>
                                {status}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row.body?.paymentDetails?.gatewayTransactionId}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {!row.accessTokenUsed && (
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedLead(row);
                                setOpenVoidDialog(true);
                              }}
                              disabled={!hasWriteAccess()}
                            >
                              <HighlightOffIcon style={{ color: "green" }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                className={classes.pagination}
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </TabPanel>
      )}

      {/* Analytics Tab */}
      {getCurrentTab()?.originalIndex === 1 && (
        <TabPanel value={tabValue} index={tabValue}>
          {isAnalyticsLoading ? (
            <AnalyticsLoadingSkeleton />
          ) : (
            <div className={classes.analyticsContainer}>
              {/* Summary Cards */}
              <Grid container spacing={3} className={classes.summaryCards}>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Total Purchases
                      </Typography>
                      <Typography variant="h4">
                        {getSummaryData().totalPurchases}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Total Sales
                      </Typography>
                      <Typography variant="h4">
                        ₹{getSummaryData().totalSales.toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Total Revenue
                      </Typography>
                      <Typography variant="h4">
                        ₹{getSummaryData().totalRevenue.toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                {/* New Ad Credits Cards */}
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Total Ad Credits Given
                      </Typography>
                      <Typography variant="h4">
                        ₹{getAdCreditsData()[0].value.toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Activated Ad Credits
                      </Typography>
                      <Typography variant="h4">
                        ₹{getAdCreditsData()[1].value.toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        Activated Codes
                      </Typography>
                      <Typography variant="h4">
                        {getSummaryData().activatedCodes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography color="textSecondary" gutterBottom>
                        WhatsApp Verified
                      </Typography>
                      <Typography variant="h4">
                        {getSummaryData().whatsappVerified}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Charts Grid */}
              <div className={classes.chartsGrid}>
                {/* Daily Purchase Amount */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Daily Purchase Amount
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                      data={getDailyAmountData()}
                      margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="date"
                        angle={-45}
                        textAnchor="end"
                        height={60}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="amount"
                        stroke="#8884d8"
                        name="Amount (₹)"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Daily Purchase Count */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Daily Purchases Count
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                      data={getDailyPurchasesData()}
                      margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="date"
                        angle={-45}
                        textAnchor="end"
                        height={60}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="purchases"
                        stroke="#82ca9d"
                        name="Purchases"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Source Distribution */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Source Distribution
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={getSourceDistributionData()}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} ${(percent * 100).toFixed(0)}%`
                        }
                      >
                        {getSourceDistributionData().map((entry) => (
                          <Cell
                            key={`cell-${entry.name}`}
                            fill={
                              entry.name === "SMB Team"
                                ? "rgb(40, 193, 82)"
                                : entry.name === "Meta Ads"
                                ? "#1E90FF"
                                : entry.name === "Google Ads"
                                ? "#FFD700"
                                : entry.name === "Callback Team"
                                ? "#9B51E0"
                                : "#D3D3D3"
                            }
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                {/* Ad Source Distribution */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Ad Source Distribution
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={getAdSourceData()}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} ${(percent * 100).toFixed(0)}%`
                        }
                      >
                        {getAdSourceData().map((entry) => (
                          <Cell
                            key={`cell-${entry.name}`}
                            fill={
                              entry.name === "Google Ads"
                                ? "#FFD700"
                                : "#1E90FF"
                            }
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                {/* Code Activation Status */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Code Activation Status
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={getCodeActivationData()}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} ${(percent * 100).toFixed(0)}%`
                        }
                      >
                        {getCodeActivationData().map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                {/* WhatsApp Verification Status */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    WhatsApp Verification Status
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={getWhatsAppStatusData()}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} ${(percent * 100).toFixed(0)}%`
                        }
                      >
                        {getWhatsAppStatusData().map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                {/* Plan Distribution */}
                <div className={classes.chartContainer}>
                  <Typography variant="h6" gutterBottom>
                    Plan Distribution
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                      data={getPlanDistributionData()}
                      margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="plan"
                        angle={-45}
                        textAnchor="end"
                        height={60}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="count" fill="#82ca9d" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          )}
        </TabPanel>
      )}

      {/* Lead Details Dialog */}
      <Dialog
        open={openLeadDialog}
        onClose={() => setOpenLeadDialog(false)}
        maxWidth="md"
        fullWidth
      >
        {selectedLead && (
          <>
            <DialogTitle>
              <div className={classes.flexRow}>
                <Typography variant="h6">
                  Lead Details - {selectedLead.body?.customer?.name}
                </Typography>
                <IconButton
                  onClick={() => setOpenLeadDialog(false)}
                  style={{ marginLeft: "auto" }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              {!selectedLead.voidInfo?.isVoided && (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">WABA Status</Typography>
                    <Chip
                      label={
                        selectedLead.assistantData
                          ? selectedLead.assistantData.isWhatsappVerified
                            ? "Verified"
                            : "Not Verified"
                          : "N/A"
                      }
                      color={
                        selectedLead.assistantData?.isWhatsappVerified
                          ? "primary"
                          : "default"
                      }
                      className={classes.chip}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">
                      WABA Progress Step
                    </Typography>
                    <Typography>
                      Step{" "}
                      {selectedLead?.assistantData?.wabaProgressStep || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">Campaign Count</Typography>
                    <Typography>{selectedLead.campaignCount || 0}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">BVBP Status</Typography>
                    <Typography>
                      {bvbpProcessMapping[
                        selectedLead?.assistantData?.bvbpProcess
                      ] || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {selectedLead.accessTokenUsed &&
                selectedLead.voidInfo?.isVoided && (
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="subtitle1">Is Voided</Typography>
                      <Chip
                        label={
                          selectedLead.voidInfo.isVoided ? "True" : "False"
                        }
                        color="primary"
                        className={classes.chip}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle1">Voided at</Typography>
                      <Typography>
                        {convertToIST(selectedLead.voidInfo.voidedAt)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle1">Reason</Typography>
                      <Typography>{selectedLead?.voidInfo.reason}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle1">Sub Reason</Typography>
                      <Typography>
                        {selectedLead?.voidInfo.subReason}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

              {/* Notes Section */}
              <div className={classes.notesSection}>
                <Typography variant="h6" gutterBottom>
                  Notes
                </Typography>
                <div className={classes.flexRow}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    variant="outlined"
                    placeholder="Add a note..."
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddNote}
                    startIcon={<AddIcon />}
                    disabled={!hasWriteAccess()}
                  >
                    Add
                  </Button>
                </div>
                <div style={{ marginTop: "16px" }}>
                  {selectedLead.notes?.map((note, index) => (
                    <div key={index} className={classes.note}>
                      <Typography variant="body2" color="textSecondary">
                        {new Date(note.timestamp).toLocaleString()}
                      </Typography>
                      <Typography>{note.content}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        By: {note.author}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenLeadDialog(false)} color="primary">
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Void Code Dialog */}
      <Dialog
        open={openVoidDialog}
        onClose={() => setOpenVoidDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ color: "red" }}>
          Mark Access Code as used?
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <FormControl fullWidth>
              <InputLabel id="void-reason-label">Select sub-reason</InputLabel>
              <Select
                labelId="void-reason-label"
                value={selectedVoidDropdown}
                onChange={(e) => setVoidDropdownHandler(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <Typography>
                        Please provide a sub-reason for voiding this access
                        code...
                      </Typography>
                    );
                  }
                  return selected;
                }}
                style={{
                  height: "52px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              >
                {VOID_REASON.map((rep) => (
                  <MenuItem key={rep} value={rep}>
                    {rep}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              label="Reason for voiding *"
              placeholder="Please provide a reason for voiding this access code..."
              value={voidReason}
              onChange={(e) => setVoidReason(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenVoidDialog(false);
              setSelectedVoidDropdown("");
            }}
            color="default"
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              handleVoidCode(selectedLead?._id, selectedLead?.accessToken)
            }
            variant="outlined"
            style={{ color: "#FF0000" }}
          >
            Void Code
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={closeSnackbar} severity={alertSeverity}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

const connectAccessCodeDashboard = connect((state) => ({
  agent: state.login.user,
  tenantDetails: state.tenant.tenant,
  permissions: state.login.permissions,
}))(AccessCodeDashboard);
export default withStyles(useStyles)(connectAccessCodeDashboard);
